/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

class Inboxes extends CacheEnabledApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'inbox';
  }

  getCampaigns(inboxId) {
    return axios.get(`${this.url}/${inboxId}/campaigns`);
  }

  deleteInboxAvatar(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/avatar`);
  }

  getAgentBot(inboxId) {
    return axios.get(`${this.url}/${inboxId}/agent_bot`);
  }

  // Testador do filtro do bot. As arvores sao opcionais: enviadas, testam a regra
  // que ainda esta no construtor; omitidas, testam a que esta salva na caixa.
  testBotFilter(
    inboxId,
    { conversationId, conversationFilters, contactFilters }
  ) {
    return axios.post(`${this.url}/${inboxId}/test_bot_filter`, {
      conversation_id: conversationId,
      bot_conversation_filters: conversationFilters,
      bot_contact_filters: contactFilters,
    });
  }

  setAgentBot(inboxId, botId) {
    return axios.post(`${this.url}/${inboxId}/set_agent_bot`, {
      agent_bot: botId,
    });
  }

  migrateToUazapi(inboxId, uazapiToken) {
    return axios.post(`${this.url}/${inboxId}/migrate_to_uazapi`, {
      uazapi_token: uazapiToken,
    });
  }

  fetchInstanceStatus(inboxId, connectionStatus = null) {
    return axios.post(`${this.url}/${inboxId}/fetch_instance_status`, {
      connection_status: connectionStatus,
    });
  }

  fetchUazapiGroups(inboxId, { force = false } = {}) {
    return axios.get(`${this.url}/${inboxId}/uazapi_groups`, {
      params: { force },
    });
  }

  importUazapiContacts(inboxId, labels = []) {
    return axios.post(`${this.url}/${inboxId}/import_uazapi_contacts`, {
      labels,
    });
  }

  importUazapiAllGroupContacts(inboxId, { labels = [], groups = [] } = {}) {
    return axios.post(
      `${this.url}/${inboxId}/import_uazapi_all_group_contacts`,
      {
        labels,
        groups,
      }
    );
  }

  // Histórico de mensagens da uazapi (#1296): `scope` é 'contacts' ou 'groups'.
  importUazapiMessages(inboxId, { scope, onlyRegistered = true } = {}) {
    return axios.post(`${this.url}/${inboxId}/import_uazapi_messages`, {
      scope,
      only_registered: onlyRegistered,
    });
  }

  updateUazapiGroupMessages(inboxId, receiveGroupMessages) {
    return axios.post(`${this.url}/${inboxId}/update_uazapi_group_messages`, {
      receive_group_messages: receiveGroupMessages,
    });
  }

  // Varredura de duplicidade da caixa inteira: mescla, contato a contato, as conversas
  // duplicadas daquela caixa. Devolve quantos contatos e quantas conversas entram na conta.
  mergeDuplicateConversations(inboxId) {
    return axios.post(`${this.url}/${inboxId}/merge_duplicate_conversations`);
  }

  importUazapiGroups(inboxId) {
    return axios.post(`${this.url}/${inboxId}/import_uazapi_groups`);
  }
}

export default new Inboxes();
